import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { Section } from './Shared';
export const FAQ = () => {
  const faqs = [{
    q: '¿Sirve para cualquier tipo de terapia?',
    a: 'Sí. El Kit fue diseñado para terapeutas holísticos de cualquier modalidad: Reiki, Registros Akáshicos, Constelaciones, Flores de Bach, Biodescodificación, Reflexología, Medicina China y cualquier práctica terapéutica que trabaje con pacientes de forma individual.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después de tu compra recibís un email con el link de descarga. En menos de 5 minutos tenés todo el sistema disponible.'
  }, {
    q: '¿Necesito imprimirlo obligatoriamente?',
    a: 'No. Podés usarlo 100% digital en tablet, laptop o celular. También podés imprimirlo si preferís trabajar en papel. Ambas opciones funcionan perfectamente.'
  }, {
    q: '¿Puedo usarlo en tablet?',
    a: 'Sí. El Kit está optimizado para uso digital en cualquier dispositivo. Muchos terapeutas lo usan directamente en iPad o tablet durante sus sesiones.'
  }, {
    q: '¿Qué diferencia tiene con una agenda común?',
    a: 'Una agenda común registra fechas. Este sistema registra procesos terapéuticos. La diferencia es que con el Kit tenés historial clínico, seguimiento de objetivos, continuidad entre sesiones y métricas de crecimiento — todo diseñado con lógica terapéutica, no administrativa.'
  }, {
    q: '¿La garantía es real?',
    a: 'Completamente real. Escribís a soportelumenakasha@gmail.com dentro de los 7 días con tu comprobante de compra y procesamos el reembolso sin cuestionamientos. Así de simple.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="max-w-3xl" data-id="element-84">
      <div className="text-center mb-12" data-id="element-85">
        <h2 className="md:text-4xl font-display font-bold mb-4 flex items-center justify-center text-[22px] text-brand-violetDark" data-id="element-86">
          <span className="mr-3" data-id="element-87">❓</span> LO QUE MÁS NOS PREGUNTAN
        </h2>
      </div>

      <div className="space-y-4" data-id="element-88">
        {faqs.map((faq, i) => <div key={i} className="glass-panel rounded-2xl overflow-hidden border-brand-gold/25 bg-white/80" data-id="element-89">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none hover:bg-brand-surfaceLight/60 transition-colors" data-id="element-90">
              <span className="font-medium pr-8 text-brand-violetDark text-[14px]" data-id="element-91">
                {faq.q}
              </span>
              <ChevronDown className={`w-5 h-5 text-brand-goldDark transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-92" />
            </button>
            <AnimatePresence data-id="element-93">
              {openIndex === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-94">
                  <div className="px-6 pb-5 text-brand-text/80 border-t border-brand-gold/20 pt-4 bg-white/60 text-[13px] leading-relaxed" data-id="element-95">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
};